import React, { useContext, useState } from "react";
import { Chip } from "@mui/material";
import { useQuery, useQueryClient } from "react-query";
import { QK } from "../../../base/qk";
import {
  getActionIssuesJobs,
  getActionJobs,
} from "../../../api/services/notification";
import { formatDateField, formatTimeToAmPm } from "../../../base/FormatTime";
import { Delete, Visibility } from "@mui/icons-material";
import TableComponent from "../../TableComponent/TableComponent";
import TaskDetailsModal from "../../PopupModal/TaskDetailsModal";
import { deleteScheduleJob } from "../../../api/services/scheduling";
import { useSnackbar } from "notistack";
import ConfirmModal from "../../ConfirmModal/ConfirmModal";
import MyContext from "../../../context/MyContext";

const ActionIssuesContent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const jobsPerPage = 10;
  const { locationID } = useContext(MyContext);
  const { data: actionJobs, isLoading } = useQuery(
    [QK.actionIssuesJobs, currentPage, locationID],
    () => getActionIssuesJobs(currentPage, locationID),
    {
      keepPreviousData: true,
      enabled: !!currentPage || !!locationID,
    }
  );

  const totalRecords = actionJobs?.count || 0;
  const totalPages = Math.ceil(totalRecords / jobsPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const handleShowTaskModal = (taskId) => {
    setSelectedTask(taskId);
    setShowTaskModal(true);
  };
  const handleDelete = (id) => {
    setShowConfirmModal(true);
    setSelectedTask(id);
  };

  const handleConfirmDelete = async () => {
    const response = await deleteScheduleJob(selectedTask);
    if (response.status === 204) {
      enqueueSnackbar("Job deleted successfully", { variant: "success" });
      queryClient.invalidateQueries(QK.actionIssuesJobs);
    } else {
      enqueueSnackbar("Error deleting job", { variant: "error" });
    }
    setShowConfirmModal(false);
  };

  const columns = [
    {
      field: "scheduled_start",
      headerName: "Date",
      render: (value) => formatDateField(value),
    },
    {
      field: "scheduled_start",
      headerName: "Time",
      render: (value) => formatTimeToAmPm(value),
    },
    {
      headerName: "Status",
      render: () => (
        <Chip label="Missed/Late Action" color="warning" size="small" />
      ),
    },
    { field: "client_name", headerName: "Service User" },
    {
      field: "candidates",
      headerName: "Employee",
      render: (candidates) =>
        candidates &&
        candidates.length > 0 &&
        candidates.map((c) => `${c.first_name} ${c.last_name}`).join(", "),
    },
    {
      field: "visit_name",
      headerName: "Action Name",
      render: (value) => value || "N/A",
    },
  ];

  const actions = [
    {
      icon: <Visibility />,
      color: "primary",
      handler: (job) => handleShowTaskModal(job.id),
    },
    {
      icon: <Delete />,
      color: "error",
      handler: (alert) => handleDelete(alert.id),
    },
  ];

  return (
    <div>
      <TableComponent
        columns={columns}
        data={actionJobs?.results || []}
        actions={actions}
        isLoading={isLoading}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
        size="small"
      />

      <TaskDetailsModal
        show={showTaskModal}
        handleClose={() => setShowTaskModal(false)}
        id={selectedTask}
      />
      <ConfirmModal
        show={showConfirmModal}
        handleClose={() => setShowConfirmModal(false)}
        handleConfirm={handleConfirmDelete}
        title="Delete Job"
        message="Are you sure you want to delete this job?"
      />
    </div>
  );
};

export default ActionIssuesContent;
